<template>
    <v-card>
        <v-card-title class="justify-center">Virtual conversation: {{ conversation.created_date }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row class="pa-2 ma-0">
                <v-col cols=3 class="py-0 px-2">Description </v-col><v-col cols=9 class="py-0 px-2">{{ conversation.description }}</v-col>
                <v-col cols=3 class="py-0 px-2">Conversation id </v-col><v-col cols=9 class="py-0 px-2">{{ conversation.id }}</v-col>
                <v-col cols=3 class="py-0 px-2">Created at      </v-col><v-col cols=9 class="py-0 px-2">{{ conversation.created_date }}</v-col>
                <v-col cols=3 class="py-0 px-2">Assistant       </v-col><v-col cols=9 class="py-0 px-2">{{ conversation.assistant_name }}</v-col>
                <v-col cols=3 class="py-0 px-2">Data store      </v-col><v-col cols=9 class="py-0 px-2">{{ conversation.vector_store }}</v-col>
                <v-col cols=3 class="py-0 px-2">File search only</v-col><v-col cols=9 class="py-0 px-2">{{ conversation.file_search_only }}</v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn color="primary" small @click="continueConversation">Continue Conversation</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="viewConversation">View</v-btn>
            <v-btn color="error" small @click="deleteConversation">Delete</v-btn>
        </v-card-actions>
        <cardVirtualConversationDelete ref="cardVirtualConversationDelete" @updateData="updateData"/>
    </v-card>
</template>

<script>
    import cardVirtualConversationDelete from "@/components/syst/openai/cardVirtualConversationDelete.vue";

    export default {
        components: {
            cardVirtualConversationDelete,
        },
        props: {
            conversation: {
                required: true,
            },
        },
        data() {
            return {
            }
        },
        methods: {
            continueConversation() {
                let route = this.$router.resolve({ path: "/syst/openai/mnOpenai/" + this.conversation.id}); 
                window.open(route.href, "_self");                
            },
            viewConversation() {
                this.$router.open('/syst/openai/conversationDetails/' + this.conversation.id);
            },
            deleteConversation() {
                this.$refs.cardVirtualConversationDelete.openDialog(this.conversation);
            },
            updateData(data) {
                this.$emit("updateData", data);
            },
        }
    }
</script>
